import React from "react";

const DeliveryNoteDetail = () => {
  return <div>DeliveryNoteDetail</div>;
};

export default DeliveryNoteDetail;
